import React from 'react';

import { PaymentOptions } from '../components/PaymentOptions';
import { RatesTable }     from '../components/Rates/RatesTable';
import { AddOns }         from '../components/Rates/AddOns';

export function Rates(){
  return (
    <div>
      <PaymentOptions />
      <h1>Rates</h1>
      <RatesTable />
      <h1>Add Ons</h1>
      <AddOns />
      <h1>Referral Discount</h1>
      <div style={{fontSize: '22px'}}>$25 OFF</div>
    </div>
  );
}
